import { H4 } from "../../../../components/typography/H4";

export const PartnerQuoteDetailHeader = () => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px] flex ">
          <H4 className="text-semantic-text-heading">견적서 상세 정보</H4>
        </div>
        <div />
      </div>
    </div>
  );
};
